import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "container additional-info mt-5"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "additional-info-header" }, " Podpowiemy Ci ile powinna kosztować naprawa ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0" }, " Automatycznie wyliczamy koszty napraw mechanicznych na podstawie ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, "pracochłonności napraw"),
  /*#__PURE__*/_createElementVNode("li", null, "aktualnych, przebadanych stawek robocizny"),
  /*#__PURE__*/_createElementVNode("li", null, "cen części na rynku")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "bold m-0" }, "Masz inne pytania?", -1)
const _hoisted_6 = { class: "bold mt-0" }
const _hoisted_7 = { class: "rollup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_arrow_up_icon = _resolveComponent("arrow-up-icon")!

  return (!_ctx.isHidden)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _createElementVNode("p", _hoisted_6, "Zadzwoń: " + _toDisplayString(_ctx.getPhoneNumber), 1),
        _createElementVNode("div", {
          class: "d-flex justify-content-end",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
        }, [
          _createElementVNode("span", _hoisted_7, [
            _createTextVNode("zwiń "),
            _createVNode(_component_arrow_up_icon, { fill: "#797979" })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}